import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { Template, TemplateType } from '@store/user/user.model';

@Component({
  selector: 'rlst-action-dropdown',
  templateUrl: './action-dropdown.component.html',
  styleUrls: ['./action-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ActionDropdownComponent {
  @Input() itemList: Array<Template>;
  @Input() currentItem: Template = null;
  @Input() itemLabel: string;
  @Input() defaultActionName: string;
  @Output() itemAction: EventEmitter<Template> =
    new EventEmitter<Template>();
  @Output() defaultAction: EventEmitter<void> = new EventEmitter<void>();

  public readonly templateType: typeof TemplateType = TemplateType;

  public emitDefaultAction(): void {
    this.defaultAction.emit();
  }

  public openItem(item: Template): void {
    this.itemAction.emit(item);
  }
}
